// extracted by css-extract-rspack-plugin
export default {"IconButton_0":"RemoveFilterButton-module__IconButton_0__Y6byb"};